import _find from 'lodash/find'
import _merge from 'lodash/merge'

import Store from '../StoreCollection.js'

let TravelAgentCollection = {}

_merge(TravelAgentCollection, Store, {
  state: {
    apiBaseUrl: '/api/travel-agent/v1'
  }
})

/*
|--------------------------------------------------------------------------
| TRAVEL AGENT CLASS
|--------------------------------------------------------------------------
*/

class TravelAgent {
  static getProfileImage(travelAgent) {
    return _find(travelAgent.all_files, f => {
      return f.owning_relationship === 'profile_image'
    })
  }
}

/*
|--------------------------------------------------------------------------
| EXPORTS
|--------------------------------------------------------------------------
*/

export default TravelAgentCollection

export { TravelAgentCollection, TravelAgent }
